import { DEFAULT_PLP_PATH } from './constants';

export const getProductUrl = (url: string) => {
  const newUrl = new URL(`https://${url}`);
  const fredHopperQuery = newUrl.searchParams.get('fh_location');
  const searchQuery = newUrl.searchParams.get('SearchTerm');

  if (searchQuery && !fredHopperQuery) {
    return {
      url: searchQuery,
      isSearch: true,
    };
  }

  return {
    url: url.replace(`${DEFAULT_PLP_PATH}?`, ''),
    isSearch: false,
  };
};
